import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import IndexTable from "../Common/IndexTable";

const Index = () => {
  const [data, setIndex] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getIndex().then((data) => setIndex(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Index")}
      <Divider align="center">
        <h1>Index</h1>
      </Divider>
      <br />
      <IndexTable data={data} searchEnabled longDescription />
    </div>
  );
};

export default Index;
